// // getTime.jsをインポート
// import GetTime from './modules/getTime';

// // getTime.jsに定義された機能を実行。
// const getTime = new GetTime();
// getTime.show();

// ((d)=>{
  // 'use strict';
import XHR from './modules/xhr';

const xhr = new XHR();
let data =!1;
let select =[!1,!1,!1];
let current=[0,0,0];
let currentList =[!1,!1,!1];
let input =[!1,!1,!1];
let resultImg = !1;
let resultSummary = !1;
let resultName = [!1,!1,!1];
let stock = [];
const url = new URL(location);
let params  =url.searchParams;
const stockmax = 8;
const inputChangeMain=(e)=>{
  if(!current[0]){
    current[0] = Number(data.items[0].id);
  }
  if(!!e){
    current=[Number(e.target.value),0,0];
  }
  let ipts = document.querySelectorAll('#select-item-1 input');
  for(let i=0;i<data.items.length;i++){
    if(data.items[i].id == current[0]){
      currentList[0] = data.items[i].combinations;
      input[0]={'value':data.items[i].id};
      resultName[0]=data.items[i].name;
      if(!!ipts&&ipts[i]){
        ipts[i].checked = true;
      }
    }
  }
  inputChangeSub();
}
const scrollFix =()=>{
  const selectInput=document.querySelectorAll('#select-item-1 li input');
  const selectItem=document.querySelectorAll('#select-item-1 li');
  const scroller = document.querySelector('#select-item-1 dd > div');
  let crtItem = !1;
  for(let i=0;i<selectInput.length;i++){
    if(selectInput[i].checked){
      crtItem = selectItem[i];
    }
  }
  const rect = crtItem.getBoundingClientRect();
  if(rect.left<0){
    scroller.scrollBy(rect.left,0)
  }else if(rect.right>scroller.getBoundingClientRect().width){
    scroller.scrollBy(rect.right-scroller.getBoundingClientRect().width,0)
  }
}
const arrSort=(i,obj)=>{
  let arr=[];
  for(let i=0;i<Object.keys(data.list[obj.linkID].list).length;i++){
    const id = data.list[obj.linkID].list[Object.keys(data.list[obj.linkID].list)[i]].id;
    if(obj.arr.indexOf(id)!=-1){
      arr.push(id);
    }
    if(i>=Object.keys(data.list[obj.linkID].list).length-1){

      return arr;
    }
  }
}
const inputChangeSub=(e)=>{
  // let ipts = document.querySelectorAll('#select-item-1 input');
  // for(let i=0;i<data.items.length;i++){
  //   if(data.items[i].id == current[0]){
  //     if(!!ipts&&ipts[i]){
  //       ipts[i].checked = true;
  //     }
  //   }
  // }

  if(!!e){
    let start =0;
    start = e.target.getAttribute('data-id');
    start = Number(start);
    current[start] = Number(e.target.value)||0;
  }

  for(let i=1;i<select.length;i++){
    select[i].innerHTML='';
    if(input[i]){
      input[i].removeEventListener('change',()=>{},!1);
      input[i]=!1;
    }
    delete resultName[i];
  }
  for(let i=0;i<currentList[0].length;i++){
    if(!!currentList[0][i].arr){
      currentList[0][i].arr=arrSort(i,currentList[0][i]);
      currentList[1] = currentList[0][i];
      if(!current[1]&&!!currentList[0][i].arr[0]){
        current[1] = Number(currentList[0][i].arr[0])||0
      }
    }
    if(!!currentList[0][i].relation&&currentList[0][i].relation[current[1]]&&currentList[0][i].relation[current[1]].length>0){
      currentList[2] = currentList[0][i];
      if(!current[2]&&currentList[0][i].relation[current[1]].length>0){
        current[2] = Number(currentList[0][i].relation[current[1]][0])||0;
        resultName[2]=currentList[0][i].name;
      }
    }else{
      currentList[2]=[];
    }
  }
  let dt;
  let dd;

  const grid1 = document.querySelector('#grid-1');
  if(!!currentList[2]&&!!currentList[2].relation&&!!currentList[2].relation[current[1]]&&currentList[2].relation[current[1]].length>0){
    grid1.classList.add('-grid');
  }else{
    grid1.classList.remove('-grid');

  }
  const mkSelect = (arr,index)=>{
    dt = document.createElement('dt');
    dt.innerText = data.list[currentList[index].linkID].name+'を選択';
    dt.classList.add('mincho')
    select[index].appendChild(dt);
    dd = document.createElement('dd');
    input[index] = document.createElement('select');
    input[index].id='select-'+index;
    input[index].setAttribute('data-id',index)

    let frg = document.createDocumentFragment();

    for(let i3=0;i3<data.list[currentList[index].linkID].list.length;i3++){
      let opt = document.createElement('option');
      let key = data.list[currentList[index].linkID].list[i3]['id'];
      if(arr.indexOf(key)!=-1){
        opt.value = key;
        opt.setAttribute('data-imgsrc','./data/img/icon_'+index+'_'+key+'.png');
        opt.innerText = data.list[currentList[index].linkID].list[i3]['name'];
        if(key==current[index]){
          // console.log(current[index],data.list[currentList[index].linkID].list[i3]['name'])
          opt.selected=true;
        }
        // console.log(opt)
        frg.appendChild(opt)
      }

      if(i3>=data.list[currentList[index].linkID].list.length-1){
        input[index].appendChild(frg);
        dd.appendChild(input[index])
        select[index].appendChild(dd);
        input[index].addEventListener('change',inputChangeSub,!1);
      }
    }
  }
  let arr =!1;
  let index = !1;
  scrollFix();
  if(!!currentList[1].arr){
    arr = currentList[1].arr;
    index =1;
    for(let i=0;i<data.list[index].list.length;i++){
      if(data.list[index].list[i]['id']==current[index]){
        resultName[index]=data.list[index].list[i]['name'];
      }
      if(i>=data.list[index].list.length-1){
        mkSelect(arr,index);
      }
    }
  }
  if(!!currentList[2]&&!!currentList[2].relation&&!!currentList[2].relation[current[1]]&&currentList[2].relation[current[1]].length>0){
    arr = currentList[2].relation[current[1]];
    index= 2;
    for(let i=0;i<data.list[index].list.length;i++){
      if(data.list[index].list[i]['id']==current[index]){
        resultName[index]=data.list[index].list[i]['name'];
      }
      if(i>=data.list[index].list.length-1){
        mkSelect(arr,index);
      }
    }
  }
  let src = './data/img/'+current[0]+'_'+current[1]+'_'+(current[2]?current[2]:0)+'.jpg';
  let img = new Image();
  img.addEventListener('load',e=>{
    resultImg.innerHTML='';
    resultImg.appendChild(img);

    resultSummary.innerHTML=resultName.join(' ');
    params.set('id',current.join('_'))
    history.pushState({}, '', url.href);

  },!1);
  img.addEventListener('error',e=>{
    console.warn('img load error')
  },!1);
  img.src=src;
  for(let i = 1; i<select.length;i++){
    // console.log(select)
    if(current[i]){
      let cnt = 0;
      if(i==1){
        cnt = currentList[i].arr.indexOf(current[i]+'');
      }else if(i==2){
        cnt = (!!currentList[i]&&!!currentList[i].relation&&!!currentList[i].relation[current[i-1]])?currentList[i].relation[current[i-1]].indexOf(current[i]+''):0;
      }

      let selectOptions = {
          dropdownHeight  : "318px",
          // imageLocation  : "left",
          // padding      : 8,
          select      : cnt,
          width      : '100%'
      }
      $('#select-'+i).gorillaDropdown(selectOptions);
      $('#select-'+i+' .ddlist').on('click', function () {
        let selected = $('#select-'+i).gorillaDropdown('selected');
        current[i] = Number(selected.value);
        inputChangeSub();
      });
    }
  }
}
const shareFunc = ()=>{
  if(!params.get('id')){
    params.delete('id')
  }
  if(!params.get('mem')){
    params.delete('mem')
  }
  const subject = 'カラー シミュレーター｜株式会社アキト FIRST RAIL SYSTEM BY AKITO';
  const summaryText = resultName.join(' ');
  const shareData={
    // title: subject,
    text: summaryText,
    url: url.href,
  }
  const mailTo = ()=>{
    let address = '';
    let body = '【ハンドレイル・シミュレーター】' + '%0D%0A' + summaryText + '%0D%0A' + url.href;
    // location.href = 'mailto:' + address + '?subject=' + subject + '&body=' + body;

    window.open('mailto:' + address + '?subject=' + subject + '&body=' + body);

  }
  if (navigator.canShare) {
    try {
      // async ()=>{
      //   // await navigator.share(shareData).then(() => {
      //   //   // success
      //   // }).catch(e=>{
      //   //     console.error(e);
      //   // });
      //   await navigator.share(shareData);
      // }
        navigator.share(shareData);
      // navigator.clipboard.writeText(url.href).then(()=>{
      //   alert('URLをクリップボードにコピーいたしました。');
      // }).catch(e=>{
      //   alert('エラー!'+e.message);
      // })
    } catch (err) {

      console.error(err);
      // console.error('Failed to copy!', err)
      mailTo()
    }
  }else{
    mailTo()
  }
}
const stockFunc = () =>{
  let btnStock =document.querySelector('button.btn-stock');
  if(stock.length>0){
    if(stock.length >= stockmax){
      if(!!btnStock){
        btnStock.disabled =true;
      }
    }else{
      if(!!btnStock){
        btnStock.disabled =false;
      }
    }
    params.set('mem',stock.join('.'))
  }else{
    params.delete('mem')
  }
  history.pushState('', '', url.href);
  let stockItem =document.querySelector('#stock-item');
  stockItem.innerHTML='';
  let frg = document.createDocumentFragment();
  const delFunc = (e)=>{
      let index = stock.indexOf(e.target.value);
      stock.splice(index, 1)
      e.target.removeEventListener('click',delFunc,!1);
      stockFunc();
  }
  const repFunc = (e)=>{
    let repID = e.target.value;
    current = [Number(repID.split('_')[0]),Number(repID.split('_')[1]),Number(repID.split('_')[2])];
    inputChangeMain();
  }
  for(let i=0;i<stock.length;i++){
    let div = document.createElement('div');
    // let url_show = url.origin+url.pathname+'?id='+stock[i]+'&mem='+params.get('mem');
    let btn_delete = document.createElement('button');
    btn_delete.type='button';
    btn_delete.value = stock[i];
    btn_delete.innerText='delete';
    btn_delete.classList.add('btn-delete');

    let btn_show = document.createElement('button');
    btn_show.type='button';
    btn_show.classList.add('btn-stock');
    btn_show.value=stock[i];
    btn_show.innerHTML='<span class="img" style="background-image:url(./data/img/'+stock[i]+'.jpg);"><img src="./data/img/'+stock[i]+'.jpg"></span>';

    btn_delete.addEventListener('click',delFunc,!1)
    btn_show.addEventListener('click',repFunc,!1)
    div.appendChild(btn_show)
    div.appendChild(btn_delete)
    frg.appendChild(div)
    if(i>=stock.length-1){
      stockItem.appendChild(frg)
    }
  }
}
const mock = (e)=>{
  data = e.target.response;
  select[0] = document.querySelector('#select-item-1');
  select[1] = document.querySelector('#select-item-2');
  select[2] = document.querySelector('#select-item-3');
  select[0].innerHTML='';
  resultImg = document.querySelector('#result-img');
  resultSummary = document.querySelector('#result-summary');
  let dt = document.createElement('dt');
  let dd = document.createElement('dd');
  let ul = document.createElement('ul');
  let wrap = document.createElement('div');
  wrap.classList.add('-wrap');
  ul.setAttribute('data-item-len',data.items.length);
  for(let i=0;i<data.items.length;i++){
    let li = document.createElement('li');
    let label = document.createElement('label');
    let ipt = document.createElement('input');
    ipt.type='radio';
    ipt.value=data.items[i].id;
    ipt.name ='model';
    if(current[0]==data.items[i].id){
      ipt.checked=true;
    }
    if(data.items[i].disabled){
      ipt.disabled=true;
    }
    let figure = document.createElement('figure');
    figure.innerHTML = '<span class="img" style="background-image:url(./data/img/thumb_'+data.items[i].id+'.png);"><img src="./data/img/thumb_'+data.items[i].id+'.png" alt="'+data.items[i].name+'"></span><figcaption>'+data.items[i].name+'</figcaption>';
    label.appendChild(ipt);
    label.appendChild(figure);
    li.appendChild(label);
    ul.appendChild(li);
    ipt.addEventListener('change',e=>{
      // console.log('change')
      inputChangeMain(e)
    },!1);
    if(i>=data.items.length-1){
      wrap.appendChild(ul)
      dd.appendChild(wrap);
      dt.classList.add('mincho')
      dt.innerText='製品タイプを選択';
      select[0].appendChild(dt)
      select[0].appendChild(dd)
      inputChangeMain();

      // if(i>=mem.length-1){
        stockFunc();
      // }
    }
  }
  const resultBtnFunc = e=>{
    if(e.target.classList.contains('btn-share')){
      shareFunc();
    }
    else if(e.target.classList.contains('btn-stock')){
      let val = current.join('_');
      if(stock.indexOf(val)==-1&&stock.length<stockmax){
        stock.push(val);
        params.set('mem',stock.join('.'))
        history.pushState('', '', url.href);
        stockFunc();
      }
    }

  }
  const resultCtrl = document.querySelector('#result-ctrl');
  const btnShare = document.createElement('button');
  btnShare.type='button';
  btnShare.classList.add('btn-share');
  btnShare.innerHTML='<span class="txt"><i></i>この組み合わせを'+(!!navigator.canShare?'共有する':'メールする')+'</span>';
  const btnStock = document.createElement('button');
  btnStock.type='button';
  btnStock.classList.add('btn-stock');
  btnStock.innerHTML='<span class="txt"><i></i>比較のために保存する</span>';

  resultCtrl.appendChild(btnShare);
  resultCtrl.appendChild(btnStock);
  btnShare.addEventListener('click',e=>{
    resultBtnFunc(e)
  },!1)
  btnShare.addEventListener('touchstart',e=>{
    resultBtnFunc(e)
  },!1)

  btnStock.addEventListener('click',e=>{
    resultBtnFunc(e)
  },!1)
  btnStock.addEventListener('touchstart',e=>{
    resultBtnFunc(e)
  },!1)



}



import PAGE_LOAD_EVENT from './modules/pageloadevent';
const ready = new PAGE_LOAD_EVENT();

ready.load((e)=>{
  let id = params.get('id');
  if(!!id){
    current = [Number(id.split('_')[0]),Number(id.split('_')[1]),Number(id.split('_')[2])];
  }
  let mem = params.get('mem');
  if(mem){
    mem = mem.split('.');
    for(let i=0;i<mem.length;i++){
      if(!!mem[i]&&stock.length<stockmax){
        stock.push(mem[i])
      }
    }
  }else{
    params.delete('mem');
  }
  xhr.get('./data/data.json', 'json', mock,!0);

});


